import React, { FC } from "react";
import cx from "classnames";
import st from "./index.module.scss";

type Props = {
  isGreenBackground?: boolean;
};

export const Ticker: FC<Props> = ({ isGreenBackground }) => {
  return (
    <div
      className={cx(
        st.container,
        isGreenBackground ? st["green-background"] : st["biege-background"]
      )}
    >
      <div
        className={cx(
          st["scrolling-container"],
          isGreenBackground ? st["green-background"] : st["biege-background"]
        )}
      >
        <span className={st.text}>
          ENERGY & MENTAL BOOST WITH LION’S MANE. ENERGY & MENTAL BOOST WITH
          LION’S MANE.
        </span>
      </div>
    </div>
  );
};
